<template lang="html">
    <canvas height="100" />
</template>

<script>
import Chart from 'chart.js';
import forEach from 'lodash.foreach';
import dropRight from 'lodash.dropright';

export default {
    props: {
        chartType: {
            type: String,
            required: false,
            default: 'line'
        },
        tableData: {
            type: Array,
            required: true
        },
        labelColumn: {
            type: String,
            required: true
        },
        dataColumns: {
            type: Object,
            required: true
        },
        hasTotalRow: {
            type: Boolean,
            default: false,
            required: false
        },
        xAxesSettings: {
            type: Array,
            required: false,
            default: function () {
                return [];
            }
        }
    },
    data: function () {
        return {
            colors: [
                'rgba(255, 99, 132, 0.9)',
                'rgba(54, 162, 235, 0.9)',
                'rgba(255, 206, 86, 0.9)',
                'rgba(75, 192, 192, 0.9)',
                'rgba(153, 102, 255, 0.9)',
                'rgba(255, 159, 64, 0.9)'
            ]
        };
    },
    watch: {
        tableData: function () {
            var convertedData = this.convertTableData();
            if (typeof this._chart === 'object') {
                this._chart.destroy();
            }
            this._chart = new Chart(this.$el, {
                type: this.chartType,
                data: {
                    labels: convertedData.labels,
                    datasets: convertedData.datasets
                },
                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero:true
                            }
                        }],
                        xAxes: this.xAxesSettings
                    }
                }
            });
        }
    },
    methods: {
        convertTableData: function () {
            var $this = this;
            var data = {};
            var labels = [];
            var tableData = $this.tableData;
            if (this.hasTotalRow === true) {
                tableData = dropRight($this.tableData);
            }
            forEach(tableData, function (row) {
                labels.push(row[$this.labelColumn]);
                forEach($this.dataColumns, function (columnDesc, columnKey) {
                    if (data.hasOwnProperty(columnKey) === false) {
                        data[columnKey] = [];
                    }
                    data[columnKey].push(row[columnKey]);
                });
            });
            var convertedData = {
                labels: labels,
                datasets: []
            };
            var colorIndex = 0;
            forEach($this.dataColumns, function (columnDesc, columnKey) {
                /**
                 * Eğer renk sayısı yetmezse ilk renge geri dön.
                 */
                if (colorIndex > 5) {
                    colorIndex = 0;
                }
                colorIndex++;
                convertedData.datasets.push({
                    label: columnDesc,
                    data: data[columnKey],
                    borderColor: $this.colors[colorIndex],
                    borderWidth: 2,
                    backgroundColor: 'rgba(255, 255, 255, 0)'
                });
            });
            return convertedData;
        }
    }
}
</script>



// WEBPACK FOOTER //
// chart.v2.vue?54246a79